export default __webpack_public_path__ + "static/media/hero-1.0558e1fa.jpeg";